import React from 'react';
import MainPage from '../../../composents/MainPage';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';

const title = 'Groups';
const headers = {
	icon: 'feather icon-user',
	title: title,
	description: 'track and manage all groups information',
};

export default function GroupPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'Client',
						field: 'client',
						render: ['name'],
					},
					{ label: 'Title', field: 'title' },
					{ label: 'Type', field: 'role' },
					{
						label: 'Description',
						field: 'note',
					},
				]}
				resource={resources.group}
				title={title}
				link="/administrators/groups"
			/>
		</MainPage>
	);
}
